import styled from 'styled-components';

export const ObservedBox = styled.div<{position?: 'absolute' | 'relative' | 'sticky'}>`
  position: ${p => p.position ?? 'relative'};
`;
